(function(global) {
  "use strict";

  var EPSILON = 0.000001;

  function number(value) {
    if (value === null || value === undefined || value === "") return null;
    var parsed = Number(String(value).trim().replace(",", "."));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function round(value, places) {
    var factor = Math.pow(10, places || 6);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  function safe(reason, message) {
    return { state: "professional_confirmation", reason: reason, message: message };
  }

  function calculate(input) {
    var length = number(input && input.length);
    var width = number(input && input.width);
    var coveragePerUnit = number(input && input.coveragePerUnit);
    var allowancePercent = number(input && input.allowancePercent);

    if (!length || !width || length <= 0 || width <= 0) {
      return safe("invalid_dimensions", "Enter room length and width in metres.");
    }
    if (length > 100 || width > 100) {
      return safe("unreasonable_dimensions", "Room dimensions look unusually large. Ask Dave before calculating.");
    }
    if (!coveragePerUnit || coveragePerUnit <= 0) {
      return safe("missing_coverage", "Quantity guidance is unavailable until verified coverage per purchasable unit is recorded.");
    }
    if (allowancePercent === null) allowancePercent = 0;
    if (allowancePercent < 0 || allowancePercent > 50) {
      return safe("invalid_allowance", "Use an allowance of 50% or less, or ask Dave for advice.");
    }

    var area = round(length * width, 6);
    var adjusted = round(area * (1 + allowancePercent / 100), 6);
    var units = Math.ceil((adjusted - EPSILON) / coveragePerUnit);
    var totalCoverage = round(units * coveragePerUnit, 6);
    var surplus = round(Math.max(0, totalCoverage - adjusted), 6);

    return {
      state: "ok",
      area: area,
      adjusted: adjusted,
      coverage: coveragePerUnit,
      units: units,
      totalCoverage: totalCoverage,
      surplus: surplus
    };
  }

  var api = { calculate: calculate };
  global.ArraUnitCoverageEngine = api;
  if (typeof global.dispatchEvent === "function" && typeof global.Event === "function") {
    global.dispatchEvent(new global.Event("af:unit-coverage-engine-ready"));
  }
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})(typeof window !== "undefined" ? window : globalThis);
